import { FormEvent } from "react";
import { IconSearch, IconShoppingBag, IconUser } from "@tabler/icons-react";
import { toBRL } from "@/utils/formatters/formatCurrency";
import { storeAssets } from "../../assets";
import styles from "./styles.module.scss";

interface StoreHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
  cartCount: number;
  cartTotal: number;
  onCartClick: () => void;
}

export function StoreHeader({ search, onSearchChange, cartCount, cartTotal, onCartClick }: StoreHeaderProps) {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    document.getElementById("produtos")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className={styles.header}>
      <div className={styles.top}>
        <div className={styles.inner}>
          <a href="/" className={styles.logoLink} aria-label="Vinci Hair Clinic — página inicial">
            <img className={styles.logo} src={storeAssets.logoVinci} alt="Vinci Hair Clinic" width="124" height="40" loading="eager" decoding="async" />
          </a>

          <form className={styles.search} role="search" onSubmit={handleSubmit}>
            <IconSearch size={17} aria-hidden="true" />
            <input
              type="search"
              value={search}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="O que você está procurando?"
              aria-label="Buscar produtos"
            />
          </form>

          <div className={styles.actions}>
            <a className={styles.subscribe} href="#newsletter">Assinar</a>
            <a className={styles.iconButton} href="/auth/sign-in" aria-label="Minha conta">
              <IconUser size={17} aria-hidden="true" />
            </a>
            <button className={styles.cartButton} type="button" onClick={onCartClick} aria-label={`Carrinho: ${cartCount} ${cartCount === 1 ? "item" : "itens"}, ${toBRL(cartTotal)}`}>
              <span className={styles.cartTotal}>{toBRL(cartTotal)}</span>
              <span className={styles.iconButton}>
                <IconShoppingBag size={17} aria-hidden="true" />
                <b>{cartCount}</b>
              </span>
            </button>
          </div>
        </div>
      </div>

      <nav className={styles.nav} aria-label="Navegação principal">
        <div className={styles.inner}>
          <a href="#produtos">Todos os produtos</a>
          <a href="#contato">Contato</a>
          <a href="/auth/sign-in">Minha conta</a>
        </div>
      </nav>
    </header>
  );
}
